const Phone = ({ type }) => {
  const regular = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6633 19.7563C20.6633 19.7563 19.5047 20.8944 19.2207 21.228C18.7582 21.7216 18.2132 21.9547 17.4988 21.9547C17.4301 21.9547 17.3568 21.9547 17.2881 21.9501C15.9279 21.8633 14.6639 21.3331 13.7159 20.8806C11.1238 19.6284 8.84771 17.8505 6.95629 15.5973C5.39461 13.7189 4.35044 11.9822 3.65891 10.1175C3.233 8.97948 3.07729 8.09283 3.14598 7.25646C3.19178 6.72173 3.39787 6.27841 3.77798 5.89907L5.33966 4.34058C5.56406 4.13035 5.80221 4.01609 6.03577 4.01609C6.32429 4.01609 6.55786 4.18976 6.70441 4.33601C6.70899 4.34058 6.71357 4.34516 6.71815 4.34973C6.99751 4.61023 7.26313 4.87989 7.54249 5.16782C7.68446 5.31407 7.83101 5.46032 7.97756 5.61114L9.22782 6.85884C9.71327 7.3433 9.71327 7.79119 9.22782 8.27565C9.09501 8.40819 8.96678 8.54073 8.83397 8.6687C8.44927 9.06175 8.75147 8.76016 8.35304 9.11665C8.34388 9.12579 8.33472 9.13036 8.33014 9.1395C7.93629 9.53255 8.00956 9.91646 8.092 10.177C8.09658 10.1907 8.10116 10.2044 8.10573 10.2181C8.43089 11.0042 8.88886 11.7446 9.58498 12.6267L9.58956 12.6312C10.8536 14.1852 12.1862 15.3963 13.6563 16.3241C13.8441 16.4429 14.0364 16.5389 14.2196 16.6303C14.3845 16.7126 14.5402 16.7902 14.673 16.8725C14.6913 16.8817 14.7097 16.8954 14.728 16.9045C14.8837 16.9822 15.0302 17.0188 15.1814 17.0188C15.5615 17.0188 15.7996 16.7811 15.8775 16.7034L16.7752 15.8076C16.9309 15.6522 17.1782 15.4648 17.4667 15.4648C17.7506 15.4648 17.9842 15.643 18.1262 15.7984C18.1308 15.803 18.1308 15.803 18.1353 15.8076L20.6587 18.3258C21.1305 18.792 20.6633 19.7563 20.6633 19.7563Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Phone;
